module.exports = __webpack_public_path__ + "Lato-Regular.6d4e78225df0cfd5fe1b.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Regular.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Regular.ttf
// module chunks = styles